import { ReactElement } from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

export const HeaderAction = ({
	IconComponent,
	...props
}: {
	IconComponent: ReactElement;
} & TouchableOpacityProps) => {
	return <TouchableOpacity {...props}>{IconComponent}</TouchableOpacity>;
};
